/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';

const loadingAnimation = keyframes`
  0%{
    stroke-dashoffset: 12em;
  }
  10%{
    stroke-dashoffset: 12em;
  }
  40%{
    stroke-dashoffset: 26.5em;
  }
  70%{
    stroke-dashoffset: 26.5em;
  }
  90%{
    stroke-dashoffset: 35.7em;
  }
  100%{
    stroke-dashoffset: 35.7em;
  }
`;

const styles: Record<string, Interpolation<Theme>> = {
  indicator: () => css`
    width: 170px;
    transform: rotate(32.5deg);

    .main-circle {
      stroke: #0056d2;
      opacity: 1;
      stroke-width: 17;
      stroke-dasharray: 11.875em;
      stroke-dashoffset: 12em;
      animation: ${loadingAnimation} 2s ease-out infinite;
      animation-delay: 0.2s;
    }

    .secondary-circle {
      stroke: #0056d2;
      opacity: 0.5;
      stroke-width: 17;
      stroke-dasharray: 11.875em;
      stroke-dashoffset: 12em;
      animation: ${loadingAnimation} 2s ease-out infinite;
      animation-delay: 0.1s;
    }

    .tertiary-circle {
      stroke: #b0e5fb;
      stroke-dasharray: 11.875em;
      stroke-dashoffset: 12em;
      opacity: 0.5;
      stroke-width: 17;
      animation: ${loadingAnimation} 2s ease-out infinite;
    }
  `,
};

type Props = {};

const TemporaryLoadingIndicator: React.FC<Props> = () => {
  return (
    <svg css={styles.indicator} viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle className="tertiary-circle" cx="37" cy="37" r="28" />
      <circle className="secondary-circle" cx="37" cy="37" r="28" />
      <circle className="main-circle" cx="37" cy="37" r="28" />
    </svg>
  );
};

export default TemporaryLoadingIndicator;
